import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const AssignOrgEmail = ({ selectedProducts, userObj }) => {
  const navigate = useNavigate();
  const { sharedObject, userToken, SetSharedObject } = useUserStore(
    (state) => ({
      sharedObject: state.sharedObject,
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const modalTriggerRef = useRef(null);
  useEffect(() => {
    setAnswers(selectedProducts);
    setSuccessFlag(false);
  }, [selectedProducts]);
  const [answers, setAnswers] = useState();
  const [processing, setProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false); //
  const [errCreateMsg, setErrCreateMsg] = useState(false);
  const setAnswer = async (email, chkd, type) => {
    const temp = [];
    for (const eml of answers) {
      if (eml.directEmailAddress === email) {
        if (type === "email") {
          eml.assignEmail = chkd;
        } else {
          eml.notify = chkd;
        }
      }
      temp.push(eml);
    }
    setAnswers(temp);
  };
  const SubmitForm = async () => {
    setErrCreateMsg(false);
    setSuccessFlag(false);
    const ID = [];
    for (const user of userObj) {
      ID.push(user.id);
    }
    const temp = [];
    const obj = [];
    let orgId = answers[0].organizationId;
    //let id = [userObj[0].id];
    for (const eml of answers) {
      let flag = !eml.sharingAllowed && eml.emailList.length === 1;
      if (eml.assignEmail && !flag) {
        temp.push(eml.directEmailId);
        obj.push(eml);
      }
    }
    if (temp.length === 0) {
      setErrCreateMsg(true);
      return;
    }
    setProcessing(true);
    let call = `/users/AssignEmail?directEmailIds=${encodeURIComponent(
      temp
    )}&users=${encodeURIComponent(ID)}`;
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetSharedObject({ ...sharedObject.getUserEmails, obj });
      setProcessing(false);
      setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      setProcessing(false);
    }
  };

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

    $('#SharedOrgEmailModal').modal('hide');
    modalTriggerRef.current?.focus();
};

  return (
    <div className="AssignOrgEmail">
      <div
        className="modal fade"
        id="SharedOrgEmailModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="shared-org-email-title"
        data-backdrop="static"
        aria-describedby="SharedOrgEmailModalDesc"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h2 
                className="modal-title " 
                id="shared-org-email-title"
                >
                Assign Organization Email
              </h2>
              <button 
                type="button" 
                className="close" 
                onClick={CloseModal} 
                aria-label="Close assign organization email"
                >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {successFlag ? (
              <div
                className="modal-body success-modal-body"
                role="alert"
                aria-live="polite"
                aria-atomic="true"
              >
                <div className="bi-success-check" aria-hidden="true">
                  <i className="bi bi-check2-circle" ></i>
                </div>
                <div className="message-wrapper">
                  The organization email has been assigned successfully.
                </div>
              </div>
            ) : (
              <div className="modal-body">
                <p id="SharedOrgEmailModalDesc" className="sr-only">
                  Select one or more organization emails to assign to the selected users.
                </p>
                <div className="descript2-container">
                  The following list of organization emails can be selected for
                  users to send and receive all emails from the same mailbox.
                </div>
                <fieldset>
                    <legend className="sr-only">Select organization emails to assign</legend>
                    {selectedProducts.map((el) => {
                      return (
                        <div
                          className="spacer-margin8 spacer-margin9"
                          key={el.directEmailId}
                        >
                          <input
                            type="checkbox"
                            id={"emailCheck" + el.directEmailId}
                            name={"emailCheck" + el.directEmailId}
                            className="form-control"
                            onClick={(elem) =>
                              setAnswer(
                                el.directEmailAddress,
                                elem.target.checked,
                                "email"
                              )
                            }
                          />
                          <label htmlFor={"emailCheck" + el.directEmailId} className="spacer-margin2 sp-mx7">
                            {el.directEmailAddress}
                          </label>
                        </div>
                      );
                    })}
                </fieldset>
                {errCreateMsg ? (
                  <div
                    className={`alert alert-danger sp-margin4`}
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    At least one email must be selected.
                  </div>
                ) : null}
              </div>
            )}
            <div className="modal-footer">
              {successFlag ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  data-target="#SuccessOrgEmailModal"
                  onClick={() => SubmitForm()}
                  disabled={processing}
                  aria-busy={ processing }
                >
                   {processing ? "Assigning..." : "Assign"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseModal}
                disabled={processing}
              >
                {successFlag ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignOrgEmail;
